import type { FundraisingCampaign } from "@/types/models/FundraisingCampaign";
import { fetcherV2 } from "@gogive/services";
import useSWR, { mutate } from "swr";
import { fundraisingCampaignRoutes } from "./fundraising-campaigns.route";

export function fundraisingCampaignSwrKey(campaignId: string) {
  return [fundraisingCampaignRoutes.get(campaignId), {}] as [
    string,
    Record<string, string | number> | undefined,
  ];
}

/** Fetch fresh campaign data and replace the SWR cache entry. */
export async function revalidateFundraisingCampaign(campaignId: string) {
  const key = fundraisingCampaignSwrKey(campaignId);
  return mutate<FundraisingCampaign>(
    key,
    () => fetcherV2<FundraisingCampaign>(key),
    { revalidate: false },
  );
}

export function useFundraisingCampaign(campaignId: string | undefined) {
  const { data, error, mutate: refresh } = useSWR(
    () =>
      campaignId ? fundraisingCampaignSwrKey(campaignId) : undefined,
    fetcherV2<FundraisingCampaign>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: false,
    }
  );

  return {
    campaign: data,
    refresh,
    isLoading: !error && !data,
    isError: error,
  };
}
